<script setup lang="ts">
const site = useSiteStore();
const route = useRoute();

const showPlayNow = computed(() => route.params.contentType !== 'spingames');
</script>
<template>
  <div class="p-4">
    <div
      class="text-base-priority"
      v-html="$t('jackpots.progressive.more-info.body')"
    />
  </div>
  <div class="p-4 flex gap-2 bg-base">
    <DesignSystemButton
      rounding="lg"
      :type="showPlayNow ? 'tertiary' : 'primary'"
      class="w-full justify-center items-center"
      @click="site.deactivateModal()"
    >
      {{ $t('close') }}
    </DesignSystemButton>
    <NuxtLink
      v-if="showPlayNow"
      to="/spingames?progressive=true"
      class="w-full"
      @click="$trackEvent('ProgressiveJackpotsEvent', 'PJ_CTA_PLAY_NOW_CLICK')"
    >
      <DesignSystemButton
        rounding="lg"
        class="w-full justify-center items-center capitalize"
        @click="site.deactivateModal()"
      >
        {{ $t('play-now') }}
      </DesignSystemButton>
    </NuxtLink>
  </div>
</template>
